export default {
  originall: { id: "originall", val: "all" },
  origincommercial: { id: "origincommercial", val: "commercial" },
  originlibrary: { id: "originlibrary", val: "library" },
  originlibraryMcps: { id: "originlibraryMcps", val: "libraryMcps" },
  originlibraryNonMcps: { id: "originlibraryNonMcps", val: "libraryNonMcps" },
  origincommissioned: { id: "origincommissioned", val: "commissioned" },
  originlive: { id: "originlive", val: "live" },
};
